import React, { useContext, useEffect, useState } from "react";
import OrderContext from "../../../../context/OrderContext";
import Loader from "../../../Loader/Loader";
import $ from "jquery";
import AuthContext from "../../../../context/AuthContext";
import { useTranslation } from "react-i18next";
import moment from "moment";

const ModalComments = () => {
  let { user } = useContext(AuthContext);
  let { orderData, closeModal, addComment } = useContext(OrderContext);
  const [t, i18n] = useTranslation("common");
  const [userComment, setUserComment] = useState();
  const [pData, setPdata] = useState(orderData);

  const [isLoading, setIsLoading] = useState(true);

  function handleSubmit(event) {
    event.preventDefault();
    const comment = event.currentTarget.elements.commentForm.value;
    $("#comment-list").append(
      `<div class='comment-item'><strong> ${user.username} </strong> <br /> <i>"${event.currentTarget.elements.commentForm.value}"</i></div>`
    );
    addComment(
      event.currentTarget.elements.commentForm.value,
      orderData.data.orderId
    );
  }

  useEffect(() => {
    if (orderData.status === 200) {
      setPdata(orderData);
      setIsLoading(false);
      if (user.username != "budapester") {
        let filterObj = pData?.data?.comments.filter(
          (item) => item.author === user.username
        );
        setUserComment(filterObj);
      } else {
        setUserComment(pData?.data);
      }
    }
  }, [pData, orderData]);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  return (
    <>
      <div className="modal-header">
        <h4 className="modal-title">{t("app.Comments")}</h4>
        <button onClick={closeModal} className="btn btn-close">
          <i className="feather icon-x"></i>
        </button>
      </div>
      <div className="modal-content">
        <>
          <div className="comment-form" id="comment-list">
            {userComment?.map((coment) => (
              <div key={coment.id} className="comment-item">
                <strong>
                  {coment.author}
                  <br />
                  {coment.createdAt &&
                    moment(coment.createdAt).format("DD/MM/YY HH:mm:ss")}
                </strong>{" "}
                <br />
                <i>"{coment.content}"</i>
              </div>
            ))}
          </div>

          <div>
            <form onSubmit={handleSubmit} className="comment">
              <div className="form-group mb-2">
                <label className="form-label" htmlFor="commentForm">
                  Add Comment
                </label>
                <textarea
                  className="form-control"
                  id="commentForm"
                  rows="6"
                ></textarea>
              </div>
              <button className="btn btn-primary mr-2">
                {t("app.submit")}
              </button>
              <button type="reset" className="btn btn-light">
                clear
              </button>
            </form>
          </div>
        </>
      </div>
    </>
  );
};

export default ModalComments;
